import { useEffect, useMemo, useRef, useState } from 'react';
import { getSelos } from 'services/dashboard.service';
import { useAuth } from 'context/AuthContext';
import { ExtratoDetalheModal } from 'components/extrato-detalhe-modal';
import { useModal } from 'context/ModalContext';
import {
  getMissaoEquipe,
  getMissaoEquipeEcoa,
  getMissaoGestor,
  getPointsHistory,
  getPointsSummary,
} from 'services/achievement.service';
import { FormatNumber } from 'utils/helpers';
import { useLocation } from 'react-router-dom';
import ModalEdit from 'components/modal-edit';
import Timeline from './Component/Timeline';
import TabTitle from 'components/tab-title';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import PascoaExtratoItem from 'components/pascoa-extrato';
import { NewYearEnvelopeModal } from 'components/new-year-envelope-modal';
import { actionLog, getMyPreference } from 'services/actionlog.service';
import { CarnivalAiModal } from 'components/carnival-ai-modal';
import { getImgCarnaval, CarnivalImageData } from 'services/carnival.service';
import { CopaAlbumProvider, useCopaAlbumContext } from 'pages/Copa/CopaAlbumContext';
import { CopaThemePlayerProvider } from 'pages/Copa/CopaThemePlayerContext';
import { CopaModal } from 'pages/Copa/CopaModal';
import { abaAtivaVisivel, resolveExtratoTabs, shouldShowEcoaTab, TAB_ACOES_ECOA } from './extrato-tabs';
import PerfilHero from './components/PerfilHero';
import SecaoSelos from './components/SecaoSelos';
import { useColecaoDeSelos } from 'pages/Selos/useColecaoDeSelos';
import { useAtualizarFoto } from 'pages/Selos/useAtualizarFoto';
import CartaoCompartilhar from './components/CartaoCompartilhar';
import TopoDoPerfil from './components/TopoDoPerfil';
import BarraDeAbas, { ID_DO_PAINEL_DAS_ABAS, idDaAba } from './components/BarraDeAbas';
import Resumo, { LinhaDoExtrato } from './components/abas/Resumo';
import Reconhecimentos from './components/abas/Reconhecimentos';
import RealizacaoDestaque from './components/abas/RealizacaoDestaque';
import AcoesEcoa from './components/abas/AcoesEcoa';
import AcoesEngajamento, { CartaoSazonal } from './components/abas/AcoesEngajamento';
import CartoesCarregando from 'components/ui/cartoes-carregando';
import { usePontosPorComportamento } from './usePontosPorComportamento';
import { usePerfilNivel } from 'hooks/usePerfilNivel';
import { GetVersion } from 'services/utils';
import { isGrupoValido } from 'utils/helpers';
import { cicloEstaAberto, ItemDeSelo, lerAbaDaUrl, rotuloNivel, urlDaFoto } from './perfil-calculos';
import PontosPorFase from './components/resumo/PontosPorFase';
import ResumoReconhecimentos from './components/resumo/ResumoReconhecimentos';
import ResumoRealizacoes from './components/resumo/ResumoRealizacoes';
import { FiltroDoCiclo, usePontosPorFase } from './usePontosPorFase';
import { contagensPorCoin } from './pontos-por-fase';
import { useRealizacoesDoSemestre } from 'pages/RealizacaoDestaque/useRealizacoesDoSemestre';
import { CicloDoSemestre, contadoresDoSemestre } from 'pages/RealizacaoDestaque/realizacoes-do-semestre';

const TabsRede = ['Resumo', 'Reconhecimentos'];
const ANCORA_DOS_RECONHECIMENTOS = '#reconhecimentos';
/** Até quando o deslocamento que o navegador ainda faz depois do alinhamento é corrigido (DEST-13). */
const JANELA_DE_CORRECAO_MS = 1000;
const GESTOS_DA_PESSOA = ['wheel', 'touchstart', 'keydown', 'mousedown'];

const AVISO_RENUNCIA =
  'Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não serão convertidos em premiação.';
const AVISO_LIMITE_ENGAJAMENTO =
  'Conforme IN 403-1 item 6.5.6.4.3.1.1 A quantidade máxima de pontos em Ações de Engajamento por funcionário será de 4.000 (quatro mil) pontos por semestre.';

interface CyclePreferenceAttributes {
  task?: boolean;
  actions?: boolean;
  recognition?: boolean;
}

/**
 * Linha "Ver álbum" em Ações de Engajamento — acesso ao Álbum BB 2026 depois
 * do encerramento (RE-07), quando o modal/widget somem do Dashboard. Mesmo
 * padrão dos cards de Páscoa/Carnaval acima, mas a "carta" é o próprio
 * CopaModal (reaproveitado, só com a aba Pacote já removida — RE-07).
 *
 * Só aparece para quem participou (abriu ao menos 1 envelope): sem isso não
 * há o que ver no álbum. Precisa estar dentro de <CopaAlbumProvider> para ler
 * o estado do álbum e para o próprio CopaModal funcionar.
 */
function CopaAlbumExtratoRow() {
  const { albumState, hasLoadedOnce } = useCopaAlbumContext();
  const [showAlbum, setShowAlbum] = useState(false);

  const hasParticipated = hasLoadedOnce && albumState.repository.length > 0;
  if (!hasParticipated) return null;

  return (
    <CartaoSazonal
      etiqueta="Álbum BB 2026"
      titulo="Veja sua escalação"
      tom="verde"
      rotuloDoBotao="Ver álbum"
      onAbrir={() => setShowAlbum(true)}
    >
      <CopaModal isOpen={showAlbum} onClose={() => setShowAlbum(false)} />
    </CartaoSazonal>
  );
}

export default function Historico() {
  const [summaryList, setSummaryList] = useState<any>();
  const [pointsList, setPointsList] = useState<any[]>();

  const [missionList, setMissionList] = useState<any[]>();
  const [missionListEcoa, setMissionListEcoa] = useState<unknown[]>();

  const { user, userInfo, currentCycle, realCycle, cyclesExtended, cycleSelected, setCycleSelected, loadingInfo } = useAuth();
  const { showModal } = useModal();
  // Opções do seletor: todos os ciclos, com o rótulo e o valor que o TabTitle lê.
  const options = useMemo(
    () => (user ? (realCycle ?? []).map((ciclo: any) => ({ ...ciclo, label: ciclo.title, value: ciclo._id })) : []),
    [user, realCycle],
  );
  const location = useLocation();
  const barraDeAbasRef = useRef<HTMLDivElement>(null);
  const alinhouNaChegadaRef = useRef(false);


  const [loadingSummaryList, setLoadingSummaryList] = useState(true);
  const [loadingPointsList, setLoadingPointsList] = useState(true);
  const [loadingMissionList, setLoadingMissionList] = useState(true);
  const [loadingMissionListEcoa, setLoadingMissionListEcoa] = useState(true);
  const [withLimit, setWithLimit] = useState(false);

  const [recognitionTab, setRecognitionTab] = useState<'RECEIVED' | 'SENDED'>('RECEIVED');

  const [activeEditModal, setActiveEditModal] = useState<{
    message: string;
    id: string;
  } | null>();
  const [editMessage, setEditMessage] = useState<{
    message: string;
    id: string;
  } | null>();

  const [activeTab, setActiveTab] = useState(0);

  const [filter, setFilter] = useState<FiltroDoCiclo>({});
  const [realCycleFilter, setRealCycleFilter] = useState<any>();
  const [cyclePreference, setCyclePreference] = useState<CyclePreferenceAttributes | null>(null);
  const [showModalCardPascoa, setShowModalCardPascoa] = useState(false);
  const [carnivalData, setCarnivalData] = useState<CarnivalImageData | null>(null);
  const showEcoaTab = shouldShowEcoaTab({ userInfoEcoa: userInfo?.ecoa, acaoEcoa: summaryList?.acao_ecoa });
  // O userInfo é recarregado com o ciclo global; enquanto ele recarrega ou é de outro ciclo, ele é
  // desconhecido: a aba Realização Destaque não segue o acordo do ciclo anterior (PERFIL-52) e a
  // Liderança Integradora não segue o `is_manager` dele (AJH-07 a AJH-09).
  const userInfoDoCiclo = !loadingInfo && !!realCycleFilter && cycleSelected?._id === realCycleFilter._id ? userInfo : undefined;
  const acordoDoCiclo = userInfoDoCiclo?.tipo_de_acordo;
  const ehGestorNoCiclo = !!userInfoDoCiclo?.is_manager;
  const extratoTabs = useMemo(
    () => resolveExtratoTabs({ tipoDeAcordo: acordoDoCiclo, showEcoaTab }),
    [acordoDoCiclo, showEcoaTab],
  );
  // A Rede Joga Junto tem só as duas primeiras abas, nas mesmas posições.
  const abasVisiveis = user?.extra.rede ? { labels: TabsRede, indexMap: [0, 1] } : extratoTabs;
  const { perfil: perfilNivel, carregando: carregandoPerfilNivel } = usePerfilNivel({
    chave: userInfo?.chave,
    cycleId: realCycleFilter?.value,
    grupoReserva: userInfo?.grupo,
  });
  // 2S2023 e 1S2024 mostram nível e grupo do extrato do ciclo, como a página antiga (PERFIL-49);
  // os demais ciclos usam o perfil público. Sem userInfo ainda não há chave (PERFIL-50).
  const nivelDoExtrato = realCycleFilter?.label === '2S2023' || realCycleFilter?.label === '1S2024';
  const nivelExibido = nivelDoExtrato ? summaryList?.level?.nivel : perfilNivel?.nivel;
  const grupoExibido = nivelDoExtrato ? summaryList?.level?.grupo : perfilNivel?.grupo;
  const carregandoNivel = nivelDoExtrato ? loadingSummaryList : carregandoPerfilNivel || !userInfo;
  const pontosPorComportamento = usePontosPorComportamento(user?._id, filter);
  const mostrarNivel = !user?.extra?.rede && (carregandoNivel || isGrupoValido(grupoExibido ?? ''));
  // `get_selos` só serve ao selo sobre a foto: o servidor corta a lista (SEL-L03). Total e seção vêm da coleção.
  const [selos, setSelos] = useState<ItemDeSelo[]>([]);
  const { carga: cargaDosSelos, recarregar: recarregarSelos, temFoto } = useColecaoDeSelos();
  // Trocar a foto pela seção de selos ou pelo cabeçalho: com a foto nova, a coleção é relida (AJH-48).
  const abrirEditorDeFoto = useAtualizarFoto();
  const colecaoDeSelos = cargaDosSelos.estado === 'pronto' ? cargaDosSelos.dados : undefined;

  // Primeira página (AJ2-16): as seções do Resumo e o ciclo aberto x encerrado, o mesmo da pílula (AJ2-09, AJ2-34).
  const rede = !!user?.extra?.rede;
  const cicloAberto = cicloEstaAberto(realCycleFilter);
  const cicloEstendido = (cyclesExtended as unknown as CicloDoSemestre[] | undefined)?.find(ciclo => ciclo._id === realCycleFilter?._id);
  const pontosPorFase = usePontosPorFase(user?._id, filter, { inicio: currentCycle?.date_start, fim: currentCycle?.date_finish });
  // O mesmo `find/extrato` do gráfico alimenta as contagens por moeda: não há segunda leitura (AJ2-33).
  const contagensDeReconhecimento = useMemo(
    () => (pontosPorFase.carga.estado === 'pronto' ? contagensPorCoin(pontosPorFase.carga.dados.reconhecimentos) : undefined),
    [pontosPorFase.carga],
  );
  // Realização Destaque segue o acordo do ciclo exibido, como a linha do extrato e a aba (PERFIL-52).
  const mostrarRealizacoes = !rede && acordoDoCiclo === 'HIBRIDO';
  const realizacoesDoCicloAberto = useRealizacoesDoSemestre(user?._id, mostrarRealizacoes && cicloAberto ? cicloEstendido : undefined);
  const contadoresDoCicloAberto =
    user && !realizacoesDoCicloAberto.carregando && !realizacoesDoCicloAberto.erro
      ? contadoresDoSemestre(realizacoesDoCicloAberto.tarefas, user._id)
      : undefined;

  function showCardEaster() {
    setShowModalCardPascoa(true);
    actionLog(
      'me',
      'easter',
      {
        interaction: 'ver_cartao',
      },
      null,
      null,
      null,
      false,
    );
  }

  function showCardNewYear() {
    showModal && showModal('new-year-envelope-direct');
  }

  async function loadCarnivalData() {
    try {
      const data = await getImgCarnaval();
      setCarnivalData(data);
    } catch (error) {
      console.error('Erro ao carregar dados do carnaval:', error);
      setCarnivalData(null);
    }
  }

  useEffect(() => {
    const { aba, sub } = lerAbaDaUrl(location.search);
    if (aba === undefined) return;

    setActiveTab(aba);
    if (sub) setRecognitionTab(sub);

    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('active');
    searchParams.delete('sub');
    window.history.replaceState({}, '', window.location.pathname + '?' + searchParams.toString());
  }, [location]);

  /**
   * O resumo do ciclo carrega por CICLO, não por aba: além de alimentar a aba
   * Resumo, é dele que sai a visibilidade da aba ECOA de quem não tem o perfil
   * no player info. Preso à aba Resumo, trocar de ciclo estando em outra aba
   * deixava a barra de abas defasada.
   */
  useEffect(() => {
    async function loadSummary() {
      // Troca de ciclo começa do zero: o Resumo e o nível dos ciclos antigos não mostram o ciclo anterior.
      setLoadingSummaryList(true);
      try {
        const data = await getPointsSummary(user?._id, currentCycle?.date_start, currentCycle?.date_finish, filter);
        setSummaryList(data);

        setWithLimit(data?.pontos_bonus?.total + data?.acao_ecoa?.total >= 4000);

        const preferenceData = await getMyPreference(realCycleFilter?.value);

        if (!Array.isArray(preferenceData) || preferenceData.length === 0) {
          setCyclePreference(null);
        } else {
          const latestPreference = preferenceData[0];
          setCyclePreference(latestPreference?.attributes || null);
        }
      } catch (e) {
      } finally {
        setLoadingSummaryList(false);
      }
    }

    if (user && !!currentCycle && !!realCycleFilter) {
      loadSummary();
    }
  }, [user, currentCycle, realCycleFilter, filter]);

  useEffect(() => {
    async function loadData() {
      try {
        // A aba Reconhecimentos (1) carrega nos próprios componentes de lista.
        if (activeTab === 2) {
          setLoadingMissionList(true);
          const dataGestor = await getMissaoGestor(user?._id, realCycleFilter?.value);
          const dataEquipe = await getMissaoEquipe(user?._id, realCycleFilter?.value, filter);
          setMissionList([...dataGestor, ...dataEquipe]);

          setLoadingMissionList(false);
        } else if (activeTab === 3) {
          setLoadingMissionListEcoa(true);
          const dataEquipe = await getMissaoEquipeEcoa(user?._id, realCycleFilter?.value, filter);
          setMissionListEcoa(dataEquipe);

          setLoadingMissionListEcoa(false);
        } else if (activeTab === 4) {
          setLoadingPointsList(true);
          const data = await getPointsHistory(user?._id, '', '', filter);

          setPointsList(data);
          setLoadingPointsList(false);
        }
      } catch (e) {}
    }

    if (user && !!currentCycle && !!realCycleFilter) {
      loadData();
    }
  }, [user, activeTab, currentCycle, realCycleFilter, filter]);

  useEffect(() => {
    if (user?.extra.rede) {
      setActiveTab(1);
    }
  }, [user]);

  // Só decide depois que o resumo do ciclo chegou: antes disso ainda não se
  // sabe se a aba ECOA existe. Ver abaAtivaVisivel.
  useEffect(() => {
    if (summaryList && abaAtivaVisivel(activeTab, abasVisiveis.indexMap) !== activeTab) {
      setActiveTab(0);
    }
  }, [summaryList, abasVisiveis.indexMap, activeTab]);

  useEffect(() => {
    if (user?._id) {
      loadCarnivalData();
    }
  }, [user?._id]);

  useEffect(() => {
    if (!user?._id) return;

    getSelos()
      .then(setSelos)
      .catch(() => setSelos([]));
  }, [user?._id]);

  function scrollTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  function showPreferenceMessage(type: keyof CyclePreferenceAttributes) {
    return cyclePreference?.[type] === false;
  }

  function abrirAba(aba: number) {
    return () => {
      scrollTop();
      setActiveTab(aba);
    };
  }

  /** Linhas do extrato do ciclo, com as mesmas condições de exibição de antes do rebranding. */
  function linhasDoResumo(): LinhaDoExtrato[] {
    const avisoRenuncia = (dinamica: keyof CyclePreferenceAttributes) =>
      showPreferenceMessage(dinamica) ? [AVISO_RENUNCIA] : [];
    const linhas: LinhaDoExtrato[] = [];

    if (!rede) {
      linhas.push({
        chave: 'reconhecimentos',
        rotulo: 'Reconhecimentos recebidos',
        pontos: summaryList?.reconhecimentos?.total ?? 0,
        avisos: avisoRenuncia('recognition'),
        onVerMais: summaryList?.reconhecimentos?.summary?.length > 0 ? abrirAba(1) : undefined,
      });
    }

    // Mesmo acordo da aba: só o do ciclo exibido (PERFIL-52).
    if (!rede && acordoDoCiclo === 'HIBRIDO') {
      linhas.push({
        chave: 'realizacao',
        rotulo: 'Realização Destaque',
        pontos: summaryList?.realizacao_destaque?.total ?? 0,
        avisos: avisoRenuncia('task'),
        onVerMais: summaryList?.realizacao_destaque?.summary?.length > 0 ? abrirAba(2) : undefined,
      });
    }

    if (!rede && showEcoaTab) {
      linhas.push({
        chave: 'ecoa',
        rotulo: 'Ações Ecoa',
        pontos: summaryList?.acao_ecoa?.total ?? 0,
        avisos: avisoRenuncia('actions'),
        onVerMais: summaryList?.acao_ecoa?.summary?.length > 0 ? abrirAba(TAB_ACOES_ECOA) : undefined,
      });
    }

    if (summaryList?.destaques_cultura?.total) {
      linhas.push({
        chave: 'cultura',
        rotulo: 'Destaque da cultura',
        pontos: summaryList.destaques_cultura.total,
        avisos: [],
      });
    }

    if (!rede) {
      linhas.push({
        chave: 'engajamento',
        rotulo: 'Ações de Engajamento',
        pontos: summaryList?.pontos_bonus?.total || 0,
        avisos: [...avisoRenuncia('actions'), ...(withLimit ? [AVISO_LIMITE_ENGAJAMENTO] : [])],
        onVerMais: summaryList?.pontos_bonus?.summary?.length > 0 ? abrirAba(4) : undefined,
      });
    }

    return linhas;
  }

  // O topo do perfil (seletor de ciclo, foto, nível e selos) muda de altura enquanto carrega.
  const topoDoPerfilCarregado =
    !!user && !!userInfo && !carregandoNivel && cargaDosSelos.estado !== 'carregando' && options.length > 0;

  /**
   * Vindo de um link com `#reconhecimentos` (notificação), as abas ficam à vista (DEST-13). O alinhamento
   * espera o topo do perfil terminar de carregar, para a altura acima das abas não mudar depois, e acontece
   * uma vez por visita (DEST-18). Em staging, o Chrome ainda deslocou a página ~30 ms depois, sem chamada do
   * app; esse deslocamento é corrigido uma vez, até 1 s depois e só se a pessoa não mexeu na página.
   */
  useEffect(() => {
    if (alinhouNaChegadaRef.current || location.hash !== ANCORA_DOS_RECONHECIMENTOS || !topoDoPerfilCarregado) return;

    alinhouNaChegadaRef.current = true;
    const alinhar = () => barraDeAbasRef.current?.scrollIntoView({ block: 'start' });
    const encerrar = () => {
      clearTimeout(prazo);
      window.removeEventListener('scroll', corrigir);
      GESTOS_DA_PESSOA.forEach(gesto => window.removeEventListener(gesto, encerrar));
    };
    const prazo = setTimeout(encerrar, JANELA_DE_CORRECAO_MS);

    alinhar();
    const rolagemAlinhada = window.scrollY;
    // O `scroll` do próprio alinhamento chega com a página já no lugar e é ignorado.
    const corrigir = () => {
      if (window.scrollY === rolagemAlinhada) return;
      encerrar();
      alinhar();
    };
    window.addEventListener('scroll', corrigir, { passive: true });
    GESTOS_DA_PESSOA.forEach(gesto => window.addEventListener(gesto, encerrar, { passive: true }));

    return encerrar;
  }, [location.hash, topoDoPerfilCarregado]);

  return (
    <>
      <div className="mx-auto flex max-w-[1000px] flex-col gap-5 px-4 py-4 lg:px-0 lg:py-0 lg:pb-6">
        <TopoDoPerfil
          cicloLabel={realCycleFilter?.label}
          seletor={
            options?.length > 0 && (
              <TabTitle
                hideLabel
                variant="light"
                title={<></>}
                options={options}
                onCallBack={e => {
                  setFilter({ ...filter, ...{ cycleId: e?.value } });
                  setRealCycleFilter(e);
                  // Abrindo num ciclo que não é o global (ele não está na lista), o global passa a ser
                  // o exibido, para o userInfo e o acordo virem desse ciclo (PERFIL-52).
                  if (e?._id && e._id !== cycleSelected?._id) {
                    setCycleSelected({ _id: e._id, title: e.title, version: GetVersion(e.date_start) });
                  }
                }}
              />
            )
          }
        />

        {user && (
          <PerfilHero
            pessoa={{
              nome: user.name,
              matricula: user._id,
              cargo: userInfo?.funcao,
              grupo: grupoExibido,
              avatar: { ...user, ...user.extra },
              carregando: !userInfo,
            }}
            nivel={nivelExibido}
            mostrarNivel={mostrarNivel}
            carregandoNivel={carregandoNivel}
            selos={selos}
            totalDeSelos={colecaoDeSelos?.length}
            carregandoSelos={cargaDosSelos.estado === 'carregando'}
            ciclo={{ inicio: realCycleFilter?.date_start, fim: realCycleFilter?.date_end }}
            onEditarFoto={abrirEditorDeFoto}
            onVerGrupo={nivelDoExtrato ? () => showModal('group-detail-extrato') : undefined}
          />
        )}

        <div ref={barraDeAbasRef} data-testid="ancora-das-abas" className="scroll-mt-4">
          <BarraDeAbas
            rotulos={abasVisiveis.labels}
            ativa={abasVisiveis.indexMap.indexOf(activeTab)}
            onSelecionar={indice => setActiveTab(abasVisiveis.indexMap[indice])}
          />
        </div>

        <div
          role="tabpanel"
          id={ID_DO_PAINEL_DAS_ABAS}
          aria-labelledby={idDaAba(Math.max(0, abasVisiveis.indexMap.indexOf(activeTab)))}
          className="flex flex-col gap-5"
        >
          {activeTab === 0 && (
            // Só o extrato espera o resumo do ciclo: recarregá-lo (troca de foto, de ciclo) não desmonta as
            // outras seções, e o foco que estava nos selos não se perde (AJH-48).
            <div className="flex flex-col gap-[30px]">
              {loadingSummaryList ? <CartoesCarregando /> : <Resumo total={summaryList?.total} linhas={linhasDoResumo()} />}

              <PontosPorFase
                carga={pontosPorFase.carga}
                fases={cicloEstendido?.steps}
                onTentarDeNovo={pontosPorFase.recarregar}
                observar={pontosPorFase.observar}
              />

              {/* Selos e "Sua participação no ciclo" ficam só no Resumo, como no v2 (AJ2-16). */}
              {cargaDosSelos.estado !== 'carregando' && (
                <SecaoSelos
                  selos={colecaoDeSelos}
                  temFoto={temFoto}
                  onTentarDeNovo={recarregarSelos}
                  onAtualizarFoto={abrirEditorDeFoto}
                />
              )}

              {!rede && (
                <ResumoReconhecimentos
                  pontos={pontosPorComportamento}
                  ehGestor={ehGestorNoCiclo}
                  contagens={contagensDeReconhecimento}
                  totalRecebido={loadingSummaryList ? undefined : summaryList?.reconhecimentos?.total}
                  onVerTodos={abrirAba(1)}
                />
              )}

              {mostrarRealizacoes &&
                (cicloAberto ? (
                  <ResumoRealizacoes aberto contadores={contadoresDoCicloAberto} />
                ) : (
                  <ResumoRealizacoes
                    aberto={false}
                    totalDoCiclo={loadingSummaryList ? undefined : summaryList?.realizacao_destaque?.total}
                    itens={pontosPorFase.carga.estado === 'pronto' ? pontosPorFase.carga.dados.realizacoes : undefined}
                  />
                ))}

              {user && summaryList && realCycleFilter && (
                <CartaoCompartilhar
                  dados={{
                    nome: user.name,
                    linhaDeApoio: [userInfo?.diretoria || grupoExibido, `Ciclo ${realCycleFilter.label}`].filter(Boolean).join(' · '),
                    pontos: `${FormatNumber(summaryList.total)} pontos`,
                    nivel: mostrarNivel && !carregandoNivel ? rotuloNivel(nivelExibido) || undefined : undefined,
                    ciclo: realCycleFilter.label,
                  }}
                  avatar={{ ...user, ...user.extra }}
                  fotoSrc={urlDaFoto({ ...user, ...user.extra })}
                />
              )}
            </div>
          )}

          {activeTab === 1 && (
            <Reconhecimentos
              sub={recognitionTab}
              onTrocarSub={setRecognitionTab}
              pontos={pontosPorComportamento}
              ehGestor={ehGestorNoCiclo}
              filtro={filter}
              mensagemEditada={editMessage}
              onEditarEnviado={item => setActiveEditModal(item)}
            />
          )}

          {activeTab === 2 &&
            (loadingMissionList || !missionList ? (
              <CartoesCarregando />
            ) : (
              <RealizacaoDestaque
                itens={missionList}
                totalDoCiclo={summaryList?.realizacao_destaque?.total}
                cicloLabel={realCycleFilter?.label}
                linhaDoTempoAntiga={
                  (realCycleFilter?.label === '2S2023' || realCycleFilter?.label === '1S2024') && (
                    <Timeline data={missionList} cycle={realCycleFilter?.value} />
                  )
                }
              />
            ))}

          {activeTab === 3 &&
            (loadingMissionListEcoa || !missionListEcoa ? (
              <CartoesCarregando />
            ) : (
              <AcoesEcoa
                itens={missionListEcoa}
                totalDoCiclo={summaryList?.acao_ecoa?.total}
                cicloLabel={realCycleFilter?.label}
              />
            ))}

          {activeTab === 4 &&
            (loadingPointsList || !pointsList ? (
              <CartoesCarregando />
            ) : (
              <AcoesEngajamento
                itens={pointsList}
                cicloLabel={realCycleFilter?.label}
                sazonais={
                  <>
                    {/* APENAS MOSTRAR NO 1S2025 */}
                    {realCycleFilter?._id === '67ce6744ee5cff36a6f49426' && (
                      <CartaoSazonal
                        etiqueta="Páscoa de Reconhecimento"
                        titulo="Veja seu cartão de reconhecimento"
                        tom="lilas"
                        rotuloDoBotao="Ver cartão"
                        onAbrir={showCardEaster}
                      >
                        {showModalCardPascoa && <PascoaExtratoItem closeModal={() => setShowModalCardPascoa(false)} />}
                      </CartaoSazonal>
                    )}

                    {/* APENAS MOSTRAR NO 2S2025 */}
                    {realCycleFilter?._id === '68af4216458e527eaa782bec' && user?.extra?.actions !== false && (
                      <CartaoSazonal
                        etiqueta="Retrospectiva 2025"
                        titulo="Veja sua retrospectiva personalizada"
                        tom="lilas"
                        rotuloDoBotao="Ver cartão"
                        onAbrir={showCardNewYear}
                      />
                    )}

                    {/* APENAS MOSTRAR NO 1S2026 */}
                    {carnivalData &&
                      (carnivalData.latest || carnivalData.latestGenerated) &&
                      realCycleFilter?._id === '698658dc458e527eaa43981c' && (
                        <CartaoSazonal
                          etiqueta="Carnaval Joga Junto"
                          titulo="Veja sua imagem de perfil do Carnaval"
                          tom="verde"
                          rotuloDoBotao="Ver cartão"
                          onAbrir={() => showModal('carnival-ai')}
                        />
                      )}

                    {/* Álbum BB 2026 — acesso pós-encerramento (RE-07), aba Pacote já removida */}
                    {user?.extra?.actions !== false && (
                      // cycleId = cycleSelected (o mesmo que o Dashboard usa para o
                      // CopaModal/widget) — NÃO o realCycleFilter (ciclo que o
                      // Extrato está exibindo/navegando). São conceitos diferentes:
                      // o álbum é do ciclo ATUAL do jogador, independente de qual
                      // ciclo histórico ele está olhando no Extrato.
                      <CopaAlbumProvider cycleId={cycleSelected?._id}>
                        <CopaThemePlayerProvider>
                          <CopaAlbumExtratoRow />
                        </CopaThemePlayerProvider>
                      </CopaAlbumProvider>
                    )}
                  </>
                }
              />
            ))}
        </div>

      </div>

      <GroupDetailModalExtrato cycleLabel={realCycleFilter?.label} />

      <ExtratoDetalheModal />

      {/* Mount New Year modal so it can open via ModalContext */}
      <NewYearEnvelopeModal />

      <CarnivalAiModal carnivalData={carnivalData} onImageGenerated={loadCarnivalData} />

      {activeEditModal && (
        <ModalEdit
          close={() => setActiveEditModal(null)}
          data={activeEditModal}
          sendMessage={message => {
            setEditMessage(message);
            setActiveEditModal(null);
          }}
        />
      )}
    </>
  );
}
